export default __webpack_public_path__ + "static/media/osobni-doucovani-button.49c0f0f6.svg";